export default {
  surtitle: {
    id: 'address_book_empty_state_surtitle',
    defaultMessage: "Is it me you're looking for?",
  },
  title: {
    id: 'address_book_empty_state_title',
    defaultMessage: "There's no addresses",
  },
  description: {
    id: 'address_book_empty_state_description',
    defaultMessage:
      "We've looked everywhere but it looks like you have no addresses yet. Make sure to add one to be ready to sell on Back Market.",
  },
  createAddress: {
    id: 'address_book_create_new_address',
    defaultMessage: 'Create a new address',
  },
}
